(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-custom"] && !Shopify.designMode) return;
  try {
    
  class ContactFormCustom extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('.contact-form-custom__submit');
      this.inputs = this.querySelectorAll('.contact-form-custom__input, .contact-form-custom__textarea');
      
      if (!this.form || !this.submitButton) return;

      this.init();
    }

    init() {
      this.checkFormValidity();
      
      this.inputs.forEach(input => {
        input.addEventListener('input', () => this.handleInput(input));
        input.addEventListener('blur', () => this.handleBlur(input));
      });

      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    handleInput(input) {
      this.validateField(input);
      this.checkFormValidity();
    }

    handleBlur(input) {
      this.validateField(input);
      this.checkFormValidity();
    }

    validateField(field) {
      const isValid = field.checkValidity();
      
      if (field.type === 'email' && field.value.trim() !== '') {
        const emailPattern = /^[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$/i;
        const emailValid = emailPattern.test(field.value.trim());
        
        if (!emailValid) {
          field.setCustomValidity('Please enter a valid email address');
        } else {
          field.setCustomValidity('');
        }
      }

      if (field.type === 'tel' && field.value.trim() !== '') {
        const phonePattern = /^[\d\s\-\(\)]+$/;
        const phoneValid = phonePattern.test(field.value.trim()) && field.value.trim().length >= 10;
        
        if (!phoneValid) {
          field.setCustomValidity('Please enter a valid phone number');
        } else {
          field.setCustomValidity('');
        }
      }

      if (field.tagName === 'TEXTAREA' && field.value.trim() !== '') {
        if (field.value.trim().length < 10) {
          field.setCustomValidity('Message must be at least 10 characters');
        } else {
          field.setCustomValidity('');
        }
      }

      if (field.type === 'text' && field.value.trim() !== '') {
        if (field.value.trim().length < 2) {
          field.setCustomValidity('This field must be at least 2 characters');
        } else {
          field.setCustomValidity('');
        }
      }
    }

    checkFormValidity() {
      let isValid = true;

      this.inputs.forEach(input => {
        if (!input.checkValidity()) {
          isValid = false;
        }
        
        if (input.value.trim() === '' && input.hasAttribute('required')) {
          isValid = false;
        }
      });

      if (isValid) {
        this.submitButton.disabled = false;
      } else {
        this.submitButton.disabled = true;
      }
    }

    handleSubmit(e) {
      let isValid = true;

      this.inputs.forEach(input => {
        this.validateField(input);
        if (!input.checkValidity()) {
          isValid = false;
          input.reportValidity();
        }
      });

      if (!isValid) {
        e.preventDefault();
        return false;
      }

      this.submitButton.disabled = true;
      this.submitButton.textContent = 'Sending...';
    }
  }

  customElements.define('contact-form-custom', ContactFormCustom);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('.promo-slider-section');
    
    sliders.forEach(function(slider) {
      const slideshowComponent = slider.querySelector('slideshow-component');
      if (!slideshowComponent) return;

      const totalSlides = parseInt(slider.dataset.totalSlides) || 1;
      const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 5000;
      // Check if autoplay is enabled from section settings (since we disabled built-in autoplay)
      const isAutoplayEnabled = slider.dataset.autoplayEnabled === 'true';
      
      // COMPLETE PAUSE REMOVAL SYSTEM
      function completelyDisableAllPauses() {
        // Remove all hover listeners
        slideshowComponent.removeEventListener('mouseenter', slideshowComponent.suspend);
        slideshowComponent.removeEventListener('mouseleave', slideshowComponent.resume);
        slideshowComponent.removeEventListener('focusin', slideshowComponent.suspend);
        slideshowComponent.removeEventListener('focusout', slideshowComponent.resume);
        
        // Override suspend/resume methods to do nothing
        slideshowComponent.suspend = function() { /* disabled */ };
        slideshowComponent.resume = function() { /* disabled */ };
        
        // Remove paused attribute if present
        slideshowComponent.removeAttribute('paused');
        
        // Override attribute setter to prevent paused attribute
        const originalSetAttribute = slideshowComponent.setAttribute.bind(slideshowComponent);
        slideshowComponent.setAttribute = function(name, value) {
          if (name === 'paused') return; // Block paused attribute
          return originalSetAttribute(name, value);
        };
      }
      
      // Apply pause removal immediately and repeatedly
      completelyDisableAllPauses();
      setTimeout(completelyDisableAllPauses, 50);
      setTimeout(completelyDisableAllPauses, 200);
      setTimeout(completelyDisableAllPauses, 500);
      
      // Continuous monitoring to remove pause
      setInterval(completelyDisableAllPauses, 500);

      // CUSTOM AUTOPLAY SYSTEM (synchronized with progress bar)
      let customAutoplayTimeout = null;
      let isAutoplayRunning = false;
      
      function triggerNextSlide() {
        if (!document.hidden && slideshowComponent.next && isAutoplayRunning) {
          slideshowComponent.next();
        }
      }
      
      function startCustomAutoplay() {
        if (!isAutoplayEnabled || isAutoplayRunning) return;
        
        stopCustomAutoplay();
        isAutoplayRunning = true;
        
        // Schedule next slide change - will be restarted after slide change
        scheduleNextSlide();
      }
      
      function scheduleNextSlide() {
        if (!isAutoplayEnabled || !isAutoplayRunning) return;
        
        // Clear any existing timeout
        if (customAutoplayTimeout) {
          clearTimeout(customAutoplayTimeout);
        }
        
        // Schedule next slide to match progress bar timing
        customAutoplayTimeout = setTimeout(() => {
          triggerNextSlide();
        }, autoplaySpeed);
      }
      
      function stopCustomAutoplay() {
        if (customAutoplayTimeout) {
          clearTimeout(customAutoplayTimeout);
          customAutoplayTimeout = null;
        }
        isAutoplayRunning = false;
      }
      
      function restartCustomAutoplay() {
        stopCustomAutoplay();
        // Use a small delay to ensure previous timeout is cleared
        setTimeout(() => {
          if (isAutoplayEnabled && !isAutoplayRunning) {
            startCustomAutoplay();
          }
        }, 50);
      }

      // PAGINATION SYSTEM
      const paginationItems = slider.querySelectorAll('.promo-slider-pagination-item');
      if (paginationItems.length === 0) return;
      
      let currentIndex = 0;
      let progressStartTime = 0;
      let progressAnimationFrame = null;
      let lastSlideChangeTime = 0;
      const MIN_SLIDE_CHANGE_INTERVAL = 100; // Minimum ms between slide changes

      function getRealSlideIndex(rawIndex) {
        // Convert duplicated slide index to real pagination index
        return rawIndex % totalSlides;
      }

      function getCurrentSlideIndex() {
        const slides = slideshowComponent.querySelectorAll('slideshow-slide');
        for (let i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('aria-hidden') === 'false') {
            return getRealSlideIndex(i);
          }
        }
        return 0;
      }

      function updatePagination(index) {
        const realIndex = getRealSlideIndex(index);
        
        paginationItems.forEach((item, i) => {
          const fill = item.querySelector('.promo-slider-progress-fill');
          
          item.classList.remove('active', 'completed');
          
          if (i < realIndex) {
            item.classList.add('completed');
            if (fill) fill.style.width = '100%';
          } else if (i === realIndex) {
            item.classList.add('active');
            if (fill) fill.style.width = '0%';
          } else {
            if (fill) fill.style.width = '0%';
          }
        });
        
        currentIndex = realIndex;
      }

      function stopProgress() {
        if (progressAnimationFrame) {
          cancelAnimationFrame(progressAnimationFrame);
          progressAnimationFrame = null;
        }
      }

      function animateProgress() {
        if (!isAutoplayEnabled) {
          stopProgress();
          return;
        }

        const activeItem = paginationItems[currentIndex];
        if (!activeItem) {
          stopProgress();
          return;
        }
        
        const progressFill = activeItem.querySelector('.promo-slider-progress-fill');
        if (!progressFill) {
          stopProgress();
          return;
        }
        
        const elapsed = performance.now() - progressStartTime;
        const progress = Math.min((elapsed / autoplaySpeed) * 100, 100);
        
        progressFill.style.width = progress + '%';
        
        if (progress >= 100) {
          // Progress bar complete - trigger next slide (synced with autoplay)
          progressFill.style.width = '100%';
          // The autoplay timeout will trigger the slide change
          // This ensures both are perfectly synchronized
          stopProgress();
        } else {
          progressAnimationFrame = requestAnimationFrame(animateProgress);
        }
      }

      function startProgress() {
        if (!isAutoplayEnabled) return;
        
        stopProgress();
        progressStartTime = performance.now();
        
        // Start progress bar animation
        progressAnimationFrame = requestAnimationFrame(animateProgress);
        
        // Ensure autoplay is scheduled to match progress bar timing
        if (isAutoplayRunning) {
          scheduleNextSlide();
        }
      }

      function handleSlideChange(event) {
        const now = performance.now();
        // Prevent rapid-fire slide change events
        if (now - lastSlideChangeTime < MIN_SLIDE_CHANGE_INTERVAL) {
          return;
        }
        lastSlideChangeTime = now;
        
        let newIndex = 0;
        
        if (event && event.detail && event.detail.index !== undefined) {
          newIndex = getRealSlideIndex(event.detail.index);
        } else {
          newIndex = getCurrentSlideIndex();
        }
        
        // Only update if index actually changed
        if (newIndex !== currentIndex) {
          updatePagination(newIndex);
          
          // Synchronize progress bar and autoplay to start together
          if (isAutoplayEnabled) {
            // Stop both first
            stopProgress();
            stopCustomAutoplay();
            
            // Start both at exactly the same time
            const syncStartTime = performance.now();
            progressStartTime = syncStartTime;
            
            // Start progress bar
            progressAnimationFrame = requestAnimationFrame(animateProgress);
            
            // Start autoplay with same timing
            isAutoplayRunning = true;
            scheduleNextSlide();
          }
        }
      }

      function handlePaginationClick(index) {
        if (index === currentIndex) return;
        
        // Stop both progress and autoplay
        stopProgress();
        stopCustomAutoplay();
        
        if (slideshowComponent.select) {
          slideshowComponent.select(index, undefined, { animate: true });
        }
        
        // Wait for slide change, then synchronize both
        setTimeout(() => {
          updatePagination(index);
          
          // Synchronize progress bar and autoplay to start together
          if (isAutoplayEnabled) {
            const syncStartTime = performance.now();
            progressStartTime = syncStartTime;
            
            // Start progress bar
            progressAnimationFrame = requestAnimationFrame(animateProgress);
            
            // Start autoplay with same timing
            isAutoplayRunning = true;
            scheduleNextSlide();
          }
        }, 50);
      }

      // EVENT LISTENERS
      paginationItems.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          handlePaginationClick(index);
        });
      });

      slideshowComponent.addEventListener('slideshow:select', handleSlideChange);

      // Handle visibility changes
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && isAutoplayEnabled) {
          // Synchronize both when page becomes visible
          const syncStartTime = performance.now();
          progressStartTime = syncStartTime;
          
          // Start progress bar
          progressAnimationFrame = requestAnimationFrame(animateProgress);
          
          // Start autoplay with same timing
          isAutoplayRunning = true;
          scheduleNextSlide();
        } else if (document.hidden) {
          stopCustomAutoplay();
          stopProgress();
        }
      });

      // ARROW BUTTON OVERRIDE - synchronize autoplay and progress after manual navigation
      const arrowButtons = slideshowComponent.querySelectorAll('.slideshow-control');
      arrowButtons.forEach(button => {
        button.addEventListener('click', () => {
          // Wait for slide change event, then synchronize
          setTimeout(() => {
            if (isAutoplayEnabled) {
              const syncStartTime = performance.now();
              progressStartTime = syncStartTime;
              
              // Start progress bar
              progressAnimationFrame = requestAnimationFrame(animateProgress);
              
              // Start autoplay with same timing
              isAutoplayRunning = true;
              scheduleNextSlide();
            }
          }, 100);
        });
      });

      // INITIALIZATION
      setTimeout(() => {
        currentIndex = getCurrentSlideIndex();
        updatePagination(currentIndex);
        
        if (isAutoplayEnabled) {
          // Synchronize both to start together
          const syncStartTime = performance.now();
          progressStartTime = syncStartTime;
          
          // Start progress bar
          progressAnimationFrame = requestAnimationFrame(animateProgress);
          
          // Start autoplay with same timing
          isAutoplayRunning = true;
          scheduleNextSlide();
        }
      }, 100);

      // CLEANUP
      if (slider.parentNode) {
        const cleanupObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.removedNodes.forEach((node) => {
              if (node === slider || (node.nodeType === 1 && node.contains(slider))) {
                stopCustomAutoplay();
                stopProgress();
                cleanupObserver.disconnect();
              }
            });
          });
        });
        
        cleanupObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
